import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AuthSuccess() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  useEffect(() => {
    const t = sp.get("token");
    if (t) {
      localStorage.setItem("gumble_token", t);
      refresh().then(() => nav("/challenges", { replace: true }));
    } else {
      nav("/", { replace: true });
    }
    // eslint-disable-next-line
  }, []);
  return (
    <div className="min-h-screen bg-black text-white/70 flex items-center justify-center font-mono text-sm tracking-[0.3em]">
      SIGNING YOU IN...
    </div>
  );
}
